﻿import {
  Stack,
  Typography,
  IconButton,
  Button,
  List,
  FormControlLabel,
  Switch,
  LinearProgress,
  Box,
  Card,
  ListItem,
  ListItemText
} from "@mui/material";
import { memo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EditIcon from "@mui/icons-material/Edit";
import Loader from "../../common/Loader";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

const GoalListAndEdit = memo(({
  isTimeSheetsBannerFlag,
  onCloseBannerPressed,
  handleAddGoal,
  goallist,
  isProgressBarExpanded,
  setIsProgressBarExpanded,
  onEditGoalClickModal,
  editGoalModal,
  onToggleSwitch,
  isHideCompletedGoals,
  loadingGoal,
  userGoalData,
  onEditGoalClick,
  isSmallScreen
}) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const {
    TEXT_GOALS = English.TimeSheet.TEXT_GOALS,
    TEXT_ADD_GOAL = English.TimeSheet.TEXT_ADD_GOAL,
    TEXT_NO_MORE_GOALS = English.TimeSheet.TEXT_NO_MORE_GOALS,
    BUTTON_EDIT = English.TimeSheet.BUTTON_EDIT,
    BUTTON_BACK = English.TimeSheet.BUTTON_BACK,
    TEXT_EDIT_GOALS = English.TimeSheet.TEXT_EDIT_GOALS,
    TEXT_HIDE_COMPLETED_GOALS = English.TimeSheet.TEXT_HIDE_COMPLETED_GOALS,
    TEXT_GOAL_DESCRIPTION_FIRST = English.TimeSheet.TEXT_GOAL_DESCRIPTION_FIRST,
    TEXT_GOAL_DESCRIPTION_SECOND = English.TimeSheet.TEXT_GOAL_DESCRIPTION_SECOND
  } = LanguageData || {};

  const renderProgressData = (item) => {
    if (isHideCompletedGoals && item.isGoalFlag) return null;

    const progressValue = Number(
      Math.min((item.goalProgressTotalHours / item.goalHours) * 100, 100).toFixed(0)
    );

    return (
      <Stack key={item.id}>
        <Stack sx={{ justifyContent: "space-between", padding: "10px 0px" }} direction="row" width="100%">
          <Stack>
            <Typography sx={{ fontWeight: "bold" }}>{item.goalName}</Typography>
          </Stack>
          <Stack sx={{ gap: 1 }} direction={"row"} >
            <Typography  sx={{color: "primary",  fontWeight: "bold" }}>
              {item.goalProgressTotalHours}
            </Typography>
            <Typography>/ {item.goalHours} hrs</Typography>
          </Stack>
        </Stack>
        <LinearProgress
          variant="determinate"
          value={progressValue}
          sx={{
            backgroundColor: "lightgray",
            borderRadius: "10px",
            height: "5px"
          }}
        />

        {isProgressBarExpanded &&
          item.categoryList?.map((category, index) => (
            <Stack key={`${item.id}-category-${index}`} sx={{ paddingTop: "5px" }}>
              <Stack direction="row" width="100%" sx={{ justifyContent: "space-between" }}>
                <Typography>{category.categoryName}</Typography>
                <Typography>{category.categoryProgressTotalHours} hrs</Typography>
              </Stack>
            </Stack>
          ))}
      </Stack>
    );
  };

  return (
    <>
      <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
        <Typography variant="h6">{editGoalModal ? TEXT_EDIT_GOALS : TEXT_GOALS}</Typography>
        {goallist && goallist.length === 0 ? (
          <Button
            variant="contained"
            sx={{ width: "fit-content" }}
            className="active-btn"
            onClick={handleAddGoal}>
            {TEXT_ADD_GOAL}
          </Button>
        ) : (
          <Stack sx={{ flexDirection: "row", gap: 1 }}>
            <Button
              variant="contained"
              sx={{ width: "fit-content" }}
              className="active-btn"
              onClick={() => onEditGoalClickModal()}>
              {editGoalModal ? BUTTON_BACK : BUTTON_EDIT}
            </Button>
            {editGoalModal && (
              <Button
                variant="contained"
                sx={{ width: "fit-content" }}
                className="active-btn"
                onClick={handleAddGoal}>
                {TEXT_ADD_GOAL}
              </Button>
            )}
          </Stack>
        )}
      </Stack>

      <Box className="main-content-card-list">
        {isTimeSheetsBannerFlag && (
          <Stack style={{ backgroundColor: "#FFEEBF" }}>
            <Stack direction={"row"}  sx={{ gap: 1, justifyContent: "start" }} style={{ padding: "20px" }}>
              <Typography>
                {TEXT_GOAL_DESCRIPTION_FIRST} {TEXT_GOAL_DESCRIPTION_SECOND}
              </Typography>
              <IconButton
                style={{ padding: "0px", width: "21px", height: "24px" }}
                onClick={onCloseBannerPressed}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </Stack>
        )}

        {goallist && goallist.length === 0 ? (
          <Stack sx={{ display: "flex",  justifyContent: "center", alignItems: "center" }}  height={"100%"}>
            <Typography>{TEXT_NO_MORE_GOALS}</Typography>
          </Stack>
        ) : (
          <>
            {!editGoalModal ? (
              <>
                <List style={{ padding: 0 }}>
                  {goallist.map((item) => renderProgressData(item))}
                </List>
                <Stack direction="row" sx={{ justifyContent: "flex-end" }}>
                  <IconButton onClick={() => setIsProgressBarExpanded(!isProgressBarExpanded)}>
                    {isProgressBarExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </IconButton>
                </Stack>
              </>
            ) : (
              <>
                <Stack sx={{ display: "flex", pt: 1,  alignItems: "flex-start" }}>
                  <Button onClick={(e) => onToggleSwitch(e.target.checked)} size="small">
                    <FormControlLabel
                      control={
                        <Switch size="small" color="primary" checked={isHideCompletedGoals} />
                      }
                      label={
                        <Typography style={{ color: "black", textTransform: "capitalize" }}>
                          {TEXT_HIDE_COMPLETED_GOALS}
                        </Typography>
                      }
                    />
                  </Button>
                </Stack>
                <Box className="main-content-card-list">
                  {loadingGoal ? (
                    <Loader />
                  ) : (
                    <List disablePadding>
                      <Stack sx={{ gap: 1 }}>
                        {userGoalData?.map((item) => (
                          <Card
                            key={item?.id}
                            className="pagelist-content"
                            style={{ padding: "10px" }}>
                            <ListItem
                              sx={{ padding: 0 }}
                              disablePadding
                              secondaryAction={
                                <IconButton
                                  edge="end"
                                  color="primary"
                                  onClick={() => onEditGoalClick(item)}>
                                  <EditIcon />
                                </IconButton>
                              }>
                              <ListItemText sx={{ m: 0 }} primary={item.name} />
                            </ListItem>
                          </Card>
                        ))}
                      </Stack>
                    </List>
                  )}
                </Box>
              </>
            )}
          </>
        )}
      </Box>
    </>
  );
});

GoalListAndEdit.displayName = 'GoalListAndEdit';

export default GoalListAndEdit;

